import { useTranslation } from 'react-i18next'
import React from 'react'

import { Col } from '../../../../../../packages/kiti/components/structure/Grid'
import { useFormState } from '../../../../../../packages/kiti/components/form/form/FormHandler'
import EditableSentence from '../../EditableSentence'
import FormItem from '../../../../../../packages/kiti/components/form/form/FormItem'
import Modal from '../../../../../../components/structure/Modal'
import Separator from '../../../../../../packages/kiti/components/helpers/Separator'
import SubmitBar from '../../../../../../packages/kiti/components/form/SubmitBar'
import Text from '../../../../../../packages/kiti/components/presentation/Text'
import Textarea from '../../../../../../components/form/Textarea'
import SafeD4signSelect from '../../../../../../containers/integrations/SafeD4signSelect'
import FolderD4signSelect from '../../../../../../containers/integrations/FolderD4signSelect'
import PublicTokenSelect from '../../../../../../containers/publicToken/select/PublicTokenSelect'
import Select from '../../../../../../packages/kiti/components/form/Select'

const useOptions = () => {
  return [
    {
      id: 'service_order',
      name: 'atividade origem',
      value: {
        id: '::{{event.service_order.id}}',
        checklist_id: '::{{event.service_order.checklist_id}}'
      }
    }
  ]
}

const D4signAttachAtOriginSentence = () => {
  const [open, setOpen] = React.useState()
  const { t } = useTranslation('triggers')
  const { form } = useFormState()
  const options = useOptions()

  return (
    <>
      <Text size="h2">em </Text>

      <EditableSentence
        label={form.payload?.origin?.name ?? '__________'}
        truncate={20}
        onClick={() => setOpen(true)}
        field="payload"
      />

      <Modal open={open} onClose={() => setOpen(false)} disableClickOutside width="32rem">
        <Col width="100%">
          <FormItem label="Selecionar entidade origem" path={['payload', 'origin']} options={options} Input={Select} />
        </Col>

        <SubmitBar onClick={() => setOpen(false)} />
      </Modal>
    </>
  )
}

export default D4signAttachAtOriginSentence
